import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import Pagination from "../../model/pagination";
import CooperationInsightModel from "../../model/cooperationInsight.model";
import {environment} from "../../environments/environment";
import QueryEncoder from "../queryEncoder";
import {catchError, switchMap} from "rxjs/operators";
import BillingCycleModel from "../../model/billingCycle.model";

@Injectable()
export default class BillingCycleService {
    public constructor(private http: HttpClient) {
    }

    public list(query?: string, page?: number, limit?: number, sort?: string, direction?: string): Observable<Pagination<BillingCycleModel>> {
        query = query || '';
        page = page || 1;
        limit = limit || 15;
        sort = sort || '';

        let sorting = {};
        sorting[sort] = direction;

        let q = {query, page, limit, sorting};

        return this.http
            .get<Pagination<BillingCycleModel>>(environment.apiUrl + '/billing-cycles?' + QueryEncoder.encodeURI(q));
    }

    public show(id: number): Observable<BillingCycleModel> {
        return this.http.get<BillingCycleModel>(environment.apiUrl + '/billing-cycles/' + id);
    }

    public create(billingCycle: BillingCycleModel): Observable<BillingCycleModel> {
        return this.http
            .post<BillingCycleModel>(environment.apiUrl + '/billing-cycles', billingCycle);
    }

    public update(billingCycle: BillingCycleModel): Observable<any> {
        return this.http.put(environment.apiUrl + '/billing-cycles/' + billingCycle.id, billingCycle);
    }

    public delete(billingCycle: BillingCycleModel): Observable<boolean> {
        return this.http.delete(environment.apiUrl + '/billing-cycles/' + billingCycle.id).pipe(
            switchMap(result => of(true)),
            catchError(result => of(false))
        );
    }
}
